// useFetchApplicants.js
import { useState, useEffect, useCallback } from 'react';
import { useRestaurant } from '../../context/RestaurantContext';

const useFetchApplicants = (id, mode) => {
    const [employees, setEmployees] = useState([]);
    const [error, setError] = useState(null);
    const { restaurantId, loading: restaurantLoading } = useRestaurant();

    const fetchApplicants = useCallback(async () => {
        // Wait for restaurant context initialization, but don't block if restaurantId is missing.
        // Backend can fallback to restaurantId from JWT/cookie.
        if (restaurantLoading) {
            return;
        }

        try {
            const baseUrl = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/job-offers/${id}/applicants`;
            const url = restaurantId ? `${baseUrl}?restaurantId=${restaurantId}` : baseUrl;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) throw new Error('Failed to fetch');
            const apiResponse = await response.json();
            
            // Extract applicants array from API response
            const applicantsArray = apiResponse.data || apiResponse.employees || apiResponse || [];
            
            // Ensure we always have an array
            setEmployees(Array.isArray(applicantsArray) ? applicantsArray : []);
        } catch (error) {
            console.error("Error fetching applicants:", error);
            setError(error);
            setEmployees([]); // Ensure employees remains an empty array on error
        }
    }, [id, restaurantId, restaurantLoading]);

    useEffect(() => {
        if (mode === 'Applicants') {
            fetchApplicants();
        } else {
            setEmployees([]);
        }
    }, [mode, fetchApplicants]);


    return { employees, setEmployees, error };
};

export default useFetchApplicants;
